//import { DomainVerification } from "@mui/icons-material";
import React, { useState, useEffect } from "react";
import { db } from "../firebaseConfig";
import { collection, getDocs, deleteDoc, doc } from "firebase/firestore";
import AddNews from "./newsComps/AddNews";
import editIcon from "./svg/edit.svg";
import deleteIcon from "./svg/delete.svg";
import EditNews from "./newsComps/EditNews";
import AddAnnounce from "./newsComps/AddAnnounce";
import EditAnnounce from "./newsComps/EditAnnounce";
import DelAlert from "./newsComps/DelAlert";

function NewsAdmin() {
  const newsRef = collection(db, "news");
  const announcementsRef = collection(db, "announcements");
  const [news, setNews] = useState([]);
  const [announce, setAnnounce] = useState([]);
  const [activeNewsForm, setActiveNewsForm] = useState(false);
  const [activeNewsEditForm, setActiveNewsEditForm] = useState(false);
  const [activeNews, setActiveNews] = useState({
    id: "",
    title: "",
    date: "",
    lead: "",
    body: "",
  });
  const [activeNewAnnounce, setActiveNewAnnounce] = useState(false);
  const [activeAnnounceEdit, setActiveAnnounceEdit] = useState(false);
  const [activeAnnouncement, setActiveAnnouncement] = useState({
    id: "",
    title: "",
    date: "",
  });
  const [confirmDelNews, setConfirmDelNews] = useState(false);
  const [confirmDelAnnounce, setConfirmDelAnnounce] = useState(false);
  const [deleteNewsId, setDeleteNewsId] = useState("");
  const [deleteAnnounceId, setDeleteAnnounceId] = useState("");

  const getNews = async () => {
    const data = await getDocs(newsRef);
    setNews(
      data.docs
        .map((doc) => ({ ...doc.data(), id: doc.id }))
        .sort((a, b) => {
          let da = new Date(a.date);
          let db = new Date(b.date);
          return db - da;
        })
    );
  };
  const getAnnouncements = async () => {
    const data = await getDocs(announcementsRef);
    setAnnounce(
      data.docs
        .map((doc) => ({ ...doc.data(), id: doc.id }))
        .sort((a, b) => {
          let da = new Date(a.date);
          let db = new Date(b.date);
          return db - da;
        })
    );
  };
  useEffect(() => {
    getNews();
    getAnnouncements();
  }, []);

  const blurActive = () => {
    if (
      activeNewsForm ||
      activeNewsEditForm ||
      activeNewAnnounce ||
      activeAnnounceEdit
    ) {
      return "blur";
    } else {
      return "";
    }
  };

  const renderNewsForm = () => {
    if (activeNewsForm) {
      return "block";
    } else {
      return "hidden";
    }
  };

  const closeAddNewsForm = () => {
    setActiveNewsForm(false);
  };

  const closeNewsEditForm = () => {
    setActiveNewsEditForm(false);
  };

  const deleteNews = async (id) => {
    setConfirmDelNews(false);
    const newsDoc = doc(db, "news", id);
    await deleteDoc(newsDoc);
    alert("News Deleted!");
    await getNews();
  };

  const deleteAnnounce = async (id) => {
    setConfirmDelAnnounce(false);
    const newsDoc = doc(db, "announcements", id);
    await deleteDoc(newsDoc);
    alert("Announcement Deleted!");
    await getAnnouncements();
  };

  const editClick = (ind) => {
    setActiveNews({
      id: news[ind].id,
      title: news[ind].title,
      date: news[ind].date,
      lead: news[ind].lead,
      body: news[ind].newsBody,
    });
    setActiveNewsEditForm(true);
  };

  const editAnnounceClick = (ind) => {
    setActiveAnnouncement({
      id: announce[ind].id,
      title: announce[ind].title,
      date: announce[ind].date,
    });
    setActiveAnnounceEdit(true);
  };

  const renderEditNewsForm = () => {
    if (activeNewsEditForm) {
      return (
        <EditNews
          closeForm={closeNewsEditForm}
          refreshNews={getNews}
          activeNews={activeNews}
        />
      );
    }
  };

  const renderNewAnnounce = () => {
    if (activeNewAnnounce) {
      return (
        <AddAnnounce
          closeForm={() => setActiveNewAnnounce(false)}
          refreshNews={getAnnouncements}
        />
      );
    }
  };

  const renderEditAnnounce = () => {
    if (activeAnnounceEdit) {
      return (
        <EditAnnounce
          closeForm={() => setActiveAnnounceEdit(false)}
          refreshNews={getAnnouncements}
          activeNews={activeAnnouncement}
        />
      );
    }
  };

  const renderConfirmDelNews = () => {
    if (confirmDelNews) {
      return (
        <div className="absolute h-screen w-screen bg-neutral-300 top-0 left-0 bg-opacity-50">
          <DelAlert
            title="News"
            cancel={() => {
              setConfirmDelNews(false);
            }}
            confirm={() => {
              deleteNews(deleteNewsId);
            }}
          />
        </div>
      );
    }
  };
  const renderConfirmDelAnnounce = () => {
    if (confirmDelAnnounce) {
      return (
        <div className="absolute h-screen w-screen bg-neutral-300 top-0 left-0 bg-opacity-50">
          <DelAlert
            title="Announcement"
            cancel={() => {
              setConfirmDelAnnounce(false);
            }}
            confirm={() => {
              deleteAnnounce(deleteAnnounceId);
            }}
          />
        </div>
      );
    }
  };

  return (
    <React.Fragment>
      <div className="bg-white w-full h-[100%] p-4 rounded-xl shadow-md flex flex-col gap-3">
        <div className="border-l-4 border-sky-500 pl-3">
          <h1 className="font-bold text-2xl text-slate-800">News and Announcements</h1>
          <p className="text-sm text-slate-400">Manage news articles and announcements</p>
        </div>
        <div className="flex flex-col gap-2 md:flex-row md:gap-8 flex-1 min-h-0">
          <div className="flex flex-col gap-2 flex-1 min-h-0">
            <div className="border-l-4 border-sky-300 pl-2">
              <h3 className="text-base font-semibold text-slate-700">News</h3>
            </div>
            <div className="flex flex-row justify-between items-center">
              <span className="text-xs text-slate-400">{news.length} items</span>
              <div
                className="flex items-center gap-1 bg-sky-600 text-white text-sm font-semibold px-3 h-8 rounded-lg cursor-pointer hover:bg-sky-700 transition-colors"
                onClick={() => setActiveNewsForm(true)}
              >
                <span className="text-lg leading-none">+</span> Add News
              </div>
            </div>
            <div className="flex-1 min-h-[200px] h-[calc(50vh-120px)] md:h-[calc(100vh-180px)] rounded overflow-auto border border-slate-200">
              <table className="w-full text-sm border-collapse">
                <thead className="sticky top-0 bg-slate-300 z-10">
                  <tr>
                    <th className="text-left px-3 py-2 font-semibold text-slate-700">Title</th>
                    <th className="text-left px-3 py-2 font-semibold text-slate-700 hidden md:table-cell">Date</th>
                    <th className="text-left px-3 py-2 font-semibold text-slate-700 w-20">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {news.map((val, key) => (
                    <tr
                      key={key}
                      className="odd:bg-white even:bg-slate-50 hover:bg-sky-50 transition-colors"
                    >
                      <td className="px-3 py-2 max-w-0 w-full">
                        <span className="font-medium text-slate-800 block overflow-hidden text-ellipsis line-clamp-2 md:whitespace-nowrap md:line-clamp-none">{val.title}</span>
                        <p className="text-xs text-sky-600 mt-0.5 md:hidden">{val.date}</p>
                      </td>
                      <td className="px-3 py-2 text-sky-600 hidden md:table-cell whitespace-nowrap">{val.date}</td>
                      <td className="px-3 py-2 w-20">
                        <div className="flex flex-row gap-2 items-center">
                          <img
                            className="cursor-pointer w-6 h-6"
                            src={editIcon}
                            alt="edit"
                            onClick={() => editClick(key)}
                          />
                          <img
                            className="cursor-pointer w-6 h-6"
                            src={deleteIcon}
                            alt="delete"
                            onClick={() => {
                              setConfirmDelNews(true);
                              setDeleteNewsId(val.id);
                            }}
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="flex flex-col gap-2 flex-1 min-h-0">
            <div className="border-l-4 border-sky-300 pl-2">
              <h3 className="text-base font-semibold text-slate-700">Announcements</h3>
            </div>
            <div className="flex flex-row justify-between items-center">
              <span className="text-xs text-slate-400">{announce.length} items</span>
              <div
                className="flex items-center gap-1 bg-sky-600 text-white text-sm font-semibold px-3 h-8 rounded-lg cursor-pointer hover:bg-sky-700 transition-colors"
                onClick={() => setActiveNewAnnounce(true)}
              >
                <span className="text-lg leading-none">+</span> New Announcement
              </div>
            </div>
            <div className="flex-1 min-h-[160px] h-[calc(50vh-120px)] md:h-[calc(100vh-180px)] rounded overflow-auto border border-slate-200">
              <table className="w-full text-sm border-collapse">
                <thead className="sticky top-0 bg-slate-300 z-10">
                  <tr>
                    <th className="text-left px-3 py-2 font-semibold text-slate-700">Title</th>
                    <th className="text-left px-3 py-2 font-semibold text-slate-700 hidden md:table-cell">Date</th>
                    <th className="text-left px-3 py-2 font-semibold text-slate-700 w-20">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {announce.map((val, key) => (
                    <tr
                      key={key}
                      className="odd:bg-white even:bg-slate-50 hover:bg-sky-50 transition-colors"
                    >
                      <td className="px-3 py-2 max-w-0 w-full">
                        <span className="font-medium text-slate-800 block overflow-hidden text-ellipsis line-clamp-2 md:whitespace-nowrap md:line-clamp-none">{val.title}</span>
                        <p className="text-xs text-sky-600 mt-0.5 md:hidden">{val.date}</p>
                      </td>
                      <td className="px-3 py-2 text-sky-600 hidden md:table-cell whitespace-nowrap">{val.date}</td>
                      <td className="px-3 py-2 w-20">
                        <div className="flex flex-row gap-2 items-center">
                          <img
                            className="cursor-pointer w-6 h-6"
                            src={editIcon}
                            alt="edit"
                            onClick={() => editAnnounceClick(key)}
                          />
                          <img
                            className="cursor-pointer w-6 h-6"
                            src={deleteIcon}
                            alt="delete"
                            onClick={() => {
                              setConfirmDelAnnounce(true);
                              setDeleteAnnounceId(val.id);
                            }}
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <AddNews
        renderNewsForm={renderNewsForm}
        closeForm={closeAddNewsForm}
        refreshNews={getNews}
      />
      {renderEditNewsForm()}
      {renderNewAnnounce()}
      {renderEditAnnounce()}
      {renderConfirmDelNews()}
      {renderConfirmDelAnnounce()}
    </React.Fragment>
  );
}

export default NewsAdmin;
